import type { MutationState } from "@tanstack/react-query";
import { useMutationState } from "@tanstack/react-query";

import { signalsQueryKeys } from "app/pages/sales-intelligence/sub-modules/signals/query/key-factory";

import type { CreateSignalResult } from "./useCreateSignalMutation";

export function useCreateSignalMutationState(keyIdentifier?: string): MutationState<CreateSignalResult> | undefined {
    const createSignalMutationState = useMutationState<MutationState<CreateSignalResult>>({
        filters: { mutationKey: signalsQueryKeys.createSignal(keyIdentifier) },
    });

    return createSignalMutationState[createSignalMutationState.length - 1];
}
